import { render, staticRenderFns } from "./correctionNotebook.vue?vue&type=template&id=09c948b6&scoped=true"
import script from "./correctionNotebook.vue?vue&type=script&lang=js"
export * from "./correctionNotebook.vue?vue&type=script&lang=js"
import style0 from "./correctionNotebook.vue?vue&type=style&index=0&id=09c948b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c948b6",
  null
  
)

export default component.exports